<template>
    <v-dialog
        v-model="$props.params.addEditAppDialog"
        max-width="600px"
        transition="dialog-bottom-transition"
        @keydown.esc="closeAddEditAppDialog()"
        @click:outside="closeAddEditAppDialog()"
    >
        <v-card>

            <v-form @submit.prevent="processEditApp()">
                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >
                    <v-icon v-if="$props.hasOwnProperty('params') && $props.params.hasOwnProperty('app') && $props.params.app.hasOwnProperty('mode') && $props.params?.app?.mode === 'add'" class="mr-3"
                            v-text="icons.mdiPlusCircleOutline"></v-icon>
                    <v-icon v-else class="mr-3" v-text="icons.mdiPencilCircleOutline"></v-icon>
                    <div v-if="$props.params.app.mode === 'add'"
                         v-text="$gettextInterpolate($gettext('Add a time condition for %{ appName }'), {appName: $props.params.app.appName})"></div>
                    <div v-else-if="$props.params.app.mode === 'edit'"
                         v-text="$gettextInterpolate($gettext('Time condition for %{ appName }'), {appName: $props.params.app.appName})"></div>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" v-text="icons.mdiClose" @click.native.stop="closeAddEditAppDialog()"></v-icon>
                    <v-icon v-text="icons.mdiContentSave" @click.native.stop="processEditApp()"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-4">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <p class="subtitle-1 mb-0" v-text="$gettext('Please pick the day(s)')"></p>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <div>
                                    <v-checkbox v-model="addTimeConditionDays"
                                                :error-messages="addTimeConditionDaysErrors"
                                                :label="$gettext('Monday')"
                                                class="mt-0"
                                                color="primary"
                                                hide-details
                                                required
                                                value="1"
                                                @blur="$v.addTimeConditionDays.$touch()"
                                                @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Tuesday')"
                                        color="primary"
                                        hide-details
                                        required
                                        value="2"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Wednesday')"
                                        color="primary"
                                        hide-details
                                        value="3"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Thursday')"
                                        color="primary"
                                        hide-details
                                        value="4"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                </div>
                            </v-col>

                            <v-col
                                cols="12" md="6" sm="12"
                            >
                                <div>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Friday')"
                                        class="mt-0"
                                        color="primary"
                                        hide-details
                                        value="5"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Saturday')"
                                        color="primary"
                                        hide-details
                                        value="6"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Sunday')"
                                        color="primary"
                                        hide-details
                                        value="7"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <div>
                                    <v-text-field
                                        v-model="addScheduleFrom"
                                        :error-messages="addScheduleFromErrors"
                                        :label="$gettext('From')"
                                        format="24hr"
                                        outlined
                                        type="time"
                                        @blur="$v.addScheduleFrom.$touch()"
                                        @input="$v.addScheduleFrom.$touch()"
                                    ></v-text-field>
                                </div>
                            </v-col>

                            <v-col cols="12" md="6">
                                <div>
                                    <v-text-field
                                        v-model="addScheduleTo"
                                        :error-messages="addScheduleToErrors"
                                        :label="$gettext('To')"
                                        format="24hr"
                                        outlined
                                        type="time"
                                        @blur="$v.addScheduleTo.$touch()"
                                        @input="$v.addScheduleTo.$touch()"
                                    ></v-text-field>
                                </div>
                            </v-col>

                            <v-col class="py-0" cols="12">

                                <v-text-field
                                    v-model="timeAllowed"
                                    :error-messages="timeAllowedErrors"
                                    :label="$gettext('Overall Time Allowed (HH:MM)')"
                                    outlined
                                    placeholder="HH:MM"
                                    @blur="$v.timeAllowed.$touch()"
                                    @input="$v.timeAllowed.$touch()"
                                ></v-text-field>

                            </v-col>

                            <v-col class="py-0" cols="6">

                                <v-text-field
                                    v-model="maxByDay"
                                    :label="$gettext('Max By Day')"
                                    outlined
                                    type="number"
                                ></v-text-field>

                            </v-col>

                            <v-col class="py-0" cols="6">

                                <v-text-field
                                    v-model="maxByWeek"
                                    :label="$gettext('Max By Week')"
                                    outlined
                                    type="number"
                                ></v-text-field>

                            </v-col>
                            <v-col class="py-0" cols="12">
                                <div>
                                    <!-- :label="(strictEnd === 1) ? $gettext('Strict End') : $gettext('Not a Strict End')"-->
                                    <v-switch
                                        v-model="strictEnd"
                                        :class="{'o-60': strictEnd !== 1}"
                                        :false-value="0"
                                        :true-value="1"
                                        class="mt-0 transition-ease-in-out"
                                        color="primary"
                                        inset
                                        label="Strict End"
                                        value="1"
                                    ></v-switch>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-text="$gettext('Close')"
                           @click.native.stop="closeAddEditAppDialog()"></v-btn>
                    <v-btn color="primary" type="submit" v-text="$gettext('Save')"></v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>

import Vue from 'vue'
import {find, findIndex, isInteger, size} from 'lodash'

import Vuelidate from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinLodashPadStart from '@/mixins/lodash/MixinLodashPadStart'
import MixinApps from '@/mixins/apps/MixinApps'
import {mapWritableState} from 'pinia'
import {usePhonesStore} from '@/stores/PhonesStore'
import MixinConfigRules from '@/mixins/database/MixinConfigRules'
import MixinTimeConditions from '@/mixins/time_conditions/MixinTimeConditions'

Vue.use(Vuelidate)
const mustHaveAnElement = (value) => value.length > 0

export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinLodashPadStart, MixinApps, MixinConfigRules, MixinTimeConditions],
    props: {
        params: {
            required: true,
            type: Object | Array
        },
    },
    mounted() {

        let self = this

        if (self.$props.params.app.mode === 'edit') {

            self.addTimeConditionDays = []
            let tempAddTimeConditionDays = []

            // loop over each character
            for (var i = 0; i < self.$props.params.app.currentTimeCondition.days.length; i++) {
                tempAddTimeConditionDays.push(self.$props.params.app.currentTimeCondition.days.charAt(i))
            }

            self.addTimeConditionDays = tempAddTimeConditionDays
            self.addScheduleFrom = self.padStart(self.$props.params.app.currentTimeCondition.from)
            self.addScheduleTo = self.padStart(self.$props.params.app.currentTimeCondition.to)
            self.strictEnd = self.$props.params.app.currentTimeCondition.strict_end
            self.timeAllowed = self.$props.params.app.currentTimeCondition.time_allowed
            self.maxByDay = self.$props.params.app.currentTimeCondition.max_by_day ? parseInt(self.$props.params.app.currentTimeCondition.max_by_day) : ''
            self.maxByWeek = self.$props.params.app.currentTimeCondition.max_by_week ? parseInt(self.$props.params.app.currentTimeCondition.max_by_week) : ''

        }

    },
    data() {
        return {

            addTimeConditionDays: [],

            addScheduleFrom: '',
            addScheduleTo: '',

            weekdays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            strictEnd: '',

            timeAllowed: '',
            maxByDay: '',
            maxByWeek: '',

        }
    },
    methods: {

        editTimeConditionForMobileApps(tcIndex, days, from, to, strictEnd, timeAllowed, maxByDay, maxByWeek) {

            let self = this

            if (tcIndex > -1 && typeof tcIndex != 'undefined' && isInteger(tcIndex)) {

                let filteredDays = days.filter(function (el) {
                    return (el != null && el !== '' && el !== ',')
                })

                let daysStr = filteredDays.join(',')
                daysStr = daysStr.replaceAll(',', '')

                let t = {
                    days: daysStr,
                    from: from,
                    to: to,
                    strict_end: strictEnd,
                    time_allowed: timeAllowed,
                    max_by_day: maxByDay ? parseInt(maxByDay) : '',
                    max_by_week: maxByWeek ? parseInt(maxByWeek) : ''
                }

                Vue.set(self.configurations[self.currentSelectedConfigurationIndex].value.applications[self.params.appIndex]['time_condition'], tcIndex, t)

            }


        },

        addTimeCondition(days, startTime, endTime, strictEnd, timeAllowed, maxByDay, maxByWeek) {

            let self = this
            let currentTimeCondition = self.configurations[self.currentSelectedConfigurationIndex].value.applications[self.params.appIndex].time_condition

            let filteredDays = days.filter(function (el) {
                return (el != null && el !== '' && el !== ',')
            })

            let daysStr = filteredDays.join(',')
            daysStr = daysStr.replaceAll(',', '')

            if (typeof currentTimeCondition === 'undefined' || currentTimeCondition === '') {
                currentTimeCondition = []
            }

            currentTimeCondition.push({
                days: daysStr,
                from: startTime,
                to: endTime,
                strict_end: strictEnd,
                time_allowed: timeAllowed,
                max_by_day: maxByDay ? parseInt(maxByDay) : '',
                max_by_week: maxByWeek ? parseInt(maxByWeek) : ''
            })

            Vue.set(self.configurations[self.currentSelectedConfigurationIndex].value.applications[self.params.appIndex], 'time_condition', currentTimeCondition)

            self.closeAddEditAppDialog();

        },

        processEditApp() {

            let self = this
            self.$v.$touch()

            if (!self.$v.$invalid) {

                if (self.params.app.mode === 'add') {

                    self.addTimeCondition(self.addTimeConditionDays, self.addScheduleFrom, self.addScheduleTo, self.strictEnd, self.timeAllowed, self.maxByDay, self.maxByWeek)
                    self.$parent.$refs.snackbar.showSnackbar(self.$gettext('Time condition added successfully'))

                } else {

                    self.editTimeConditionForMobileApps(self.params.app.tcIndex, self.addTimeConditionDays, self.addScheduleFrom, self.addScheduleTo, self.strictEnd, self.timeAllowed, self.maxByDay, self.maxByWeek)
                    self.$parent.$refs.snackbar.showSnackbar(self.$gettext('Time condition updated successfully'))

                }

                self.resetForm()
                self.closeAddEditAppDialog()

            }

        },
        closeAddEditAppDialog() {
            let self = this
            self.$parent.closeDialog('addEditAppDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.addTimeConditionDays = []
            self.addScheduleFrom = ''
            self.addScheduleTo = ''
            self.strictEnd = self.getDefaultStrictEndValue()
            self.timeAllowed = ''
        },
    },
    computed: {

        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
        }),

        addTimeConditionDaysErrors() {
            const errors = []
            if (!this.$v.addTimeConditionDays.$dirty) return errors
            !this.$v.addTimeConditionDays.required && errors.push(this.$gettext('Please choose the days.'))
            return errors
        },

        addScheduleFromErrors() {
            const errors = []
            if (!this.$v.addScheduleFrom.$dirty) return errors
            !this.$v.addScheduleFrom.required && errors.push(this.$gettext('Please provide the From value.'))
            return errors
        },
        addScheduleToErrors() {
            const errors = []
            if (!this.$v.addScheduleTo.$dirty) return errors
            !this.$v.addScheduleTo.required && errors.push(this.$gettext('Please provide the to value.'))
            return errors
        },
        timeAllowedErrors() {
            const errors = [];
            if (!this.$v.timeAllowed.$pending && this.$v.timeAllowed.$dirty) {
                if (!this.$v.timeAllowed.required) {
                    errors.push(this.$gettext('Time allowed is required'));
                }
                if (!this.$v.timeAllowed.isValidDuration) {
                    errors.push(this.$gettext('Please provide a valid duration in HH:MM format'));
                }
            }
            return errors;
        },

    },
    validations: {
        addTimeConditionDays: {
            required,
        },
        addScheduleFrom: {
            required,
        },
        addScheduleTo: {
            required,
        },
        timeAllowed: {
            required: requiredIf(function () {
                return this.isFlexible
            }),
            isValidDuration: function (value) {
                return !this.isFlexible || this.isValidDuration(value);
            },
        },
    }

}
</script>
